import { render, staticRenderFns } from "./drug.parameters.main.vue?vue&type=template&id=7d5b6098&"
import script from "./drug.parameters.main.vue?vue&type=script&lang=js&"
export * from "./drug.parameters.main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports